import { TRoomDetail } from '@/entities/room'
import { ContentBox, Icon } from '@/shared/ui'

import { Heading, Item, Label, List, Value } from '../common'

export type StructureProps = Pick<
  TRoomDetail,
  | 'roomCnt'
  | 'bathroomCnt'
  | 'sittingroomCnt'
  | 'cookroomCnt'
  | 'sharedRoom'
  | 'sharedBathroom'
  | 'sharedCookroom'
>

export const Structure = ({
  roomCnt,
  bathroomCnt,
  sittingroomCnt,
  cookroomCnt,
  sharedRoom,
  sharedBathroom,
  sharedCookroom,
}: StructureProps) => {
  return (
    <div className="w-[260px] space-y-5">
      <Heading>구조</Heading>
      <List spacing="medium" className="typo-body2 text-gray-900">
        <Item className="justify-between">
          <Label icon="room" className="font-semibold">
            방
          </Label>
          <Value>{sharedRoom ? '다인실' : `${roomCnt}개`}</Value>
        </Item>
        <Item className="justify-between">
          <Label icon="restroom" className="font-semibold">
            화장실
          </Label>
          <Value>{sharedBathroom ? '공용' : `${bathroomCnt}개`}</Value>
        </Item>
        <Item className="justify-between">
          <Label icon="kitchen" className="font-semibold">
            주방
          </Label>
          <Value>{sharedCookroom ? '공용' : `${cookroomCnt}개`}</Value>
        </Item>
        <Item className="justify-between">
          <Label icon="livingRoom" className="font-semibold">
            거실
          </Label>
          <Value>{sharedCookroom ? '공용' : `${sittingroomCnt}개`}</Value>
        </Item>
      </List>
    </div>
  )
}

type SharedPlaceMessageProps = Pick<
  TRoomDetail,
  'sharedRoom' | 'sharedBathroom' | 'sharedCookroom'
>

export const SharedPlaceMessage = ({
  sharedRoom,
  sharedBathroom,
  sharedCookroom,
}: SharedPlaceMessageProps) => {
  if (!sharedRoom && !sharedBathroom && !sharedCookroom) {
    return null
  }

  return (
    <div className="flex items-center py-1.5">
      <Icon name="alert-filled" className="text-red-500" size={24} />
      <p className="typo-body2 font-medium text-red-500">
        {(() => {
          if (sharedRoom && sharedBathroom && sharedCookroom) {
            return '방, 화장실, 주방/거실을 다른 사람들과 함께 사용합니다.'
          }

          if (sharedRoom && sharedBathroom) {
            return '방, 화장실을 다른 사람들과 함께 사용합니다.'
          }

          if (sharedRoom && sharedCookroom) {
            return '방, 주방/거실을 다른 사람들과 함께 사용합니다.'
          }

          if (sharedBathroom && sharedCookroom) {
            return '화장실, 주방/거실을 다른 사람들과 함께 사용합니다.'
          }

          if (sharedRoom) {
            return '방을 다른 사람들과 함께 사용합니다.'
          }

          if (sharedBathroom) {
            return '화장실을 다른 사람들과 함께 사용합니다.'
          }

          if (sharedCookroom) {
            return '주방/거실을 다른 사람들과 함께 사용합니다.'
          }

          return ''
        })()}
      </p>
    </div>
  )
}

export type DuplexStructureMessageProps = Pick<TRoomDetail, 'duplexStructure'>

export const DuplexStructureMessage = ({
  duplexStructure,
}: DuplexStructureMessageProps) => {
  if (!duplexStructure) {
    return null
  }

  return (
    <ContentBox spacing="medium" color="purple" className="space-y-2">
      <p className="typo-label2 font-normal text-gray-900">
        <strong className="typo-label1 font-semibold text-black">
          복층 구조의 집
        </strong>
        으로 기재된 전용 면적보다 실제 사용 면적이 더 넓습니다.
      </p>
    </ContentBox>
  )
}
